import { EventsByDate } from '~/attendee/interfaces/event.interface';

export function mergeDates(events: EventsByDate[]): EventsByDate[] {
  if (!events?.length) {
    return [];
  }
  // this reduce function reorganize the events array to avoid dates duplications
  // due to old data concat with new data
  const groupByDate = (eventsByDate, emptyMap) => {
    // The get() method returns a specified element from a Map object.
    const data = eventsByDate.get(emptyMap.date) || {};
    eventsByDate.set(emptyMap.date, {
      // when re-creating events by date array, we put data with unique date
      date: emptyMap.date,
      events: [
        // get all events for a date and put the content in the new array
        ...(data.events || []),
        // don't put empty events array in the new eventsByDate array
        ...emptyMap.events.filter((event) => Object.keys(event).length !== 0),
      ],
    });
    return eventsByDate;
  };

  // call the reduce method with events data and an empty Map
  return [...events.reduce(groupByDate, new Map()).values()];
}
